import { createContext, use } from "react";

import type { CaptionLabelProps } from "react-day-picker";

import dayjs from "@eisox/dayjs";

import { cn } from "../..";
import { Calendar } from "../../Calendar";
import { withDayOf } from "../../Calendar/calendar.helper";
import type { CalendarViewProps, DayViewOptions } from "../date-field.type";

interface DayViewProps extends CalendarViewProps, DayViewOptions {}

const ZoomOutContext = createContext<(() => void) | undefined>(undefined);

const CaptionLabel = ({ className, children }: CaptionLabelProps) => {
  const onZoomOut = use(ZoomOutContext);
  return (
    <button
      type="button"
      className={cn(className, onZoomOut && "cursor-pointer hover:text-primary-blue")}
      disabled={!onZoomOut}
      onClick={onZoomOut}
    >
      {children}
    </button>
  );
};

const DayView = ({
  selection,
  displayed,
  onDisplayedChange,
  onPeriodClick,
  onZoomOut,
  components,
  ...options
}: DayViewProps) => {
  const shared = {
    ...options,
    month: displayed.toDate(),
    onMonthChange: (month: Date) => onDisplayedChange(dayjs(month)),
    components: { ...components, CaptionLabel },
  };

  return (
    <ZoomOutContext value={onZoomOut}>
      {selection.mode === "single" ? (
        <Calendar {...shared} value={selection.value} onValueChange={day => day && onPeriodClick(day)} />
      ) : (
        <Calendar
          {...shared}
          mode="range"
          value={selection.value}
          onDayClick={day => onPeriodClick(withDayOf(selection.value[selection.activePart], day))}
        />
      )}
    </ZoomOutContext>
  );
};

DayView.displayName = "DayView";

export { DayView };
